import actionsString from '@/assets/actions.json'

const log = require('bows')('KrpanoBuilder', '[FE]')

// TODO: renderla asincrona
const createXML = jsonData => {
  if (
    jsonData &&
    jsonData.slug &&
    jsonData.coordinateSystem &&
    jsonData.viewpoints &&
    jsonData.tags &&
    jsonData.coordinateSystem &&
    jsonData.tourFunctions
  ) {
    // TODO: questo va preso da qualche parte
    let tags = actionsString

    // TODO: definire diversamente le coordinate se non sono da blender
    let sc = {}
    let hs = {}

    if (jsonData.coordinateSystem === 'blender') {
      sc = {
        x: {
          c: 'x',
          f: 100,
          o: 0
        },
        y: {
          c: 'z',
          f: -100,
          o: 0
        },
        z: {
          c: 'y',
          f: 100,
          o: 0
        }
      }

      hs = {
        x: {
          ...sc.x,
          o: 0
        },
        y: { ...sc.y },
        z: {
          ...sc.z,
          o: -1000
        }
      }
    } else if (jsonData.coordinateSystem === 'blender-90') {
      sc = {
        x: {
          c: 'y',
          f: 100,
          o: 0
        },
        y: {
          c: 'z',
          f: -100,
          o: 0
        },
        z: {
          c: 'x',
          f: -100,
          o: 0
        }
      }

      hs = {
        x: {
          ...sc.x,
          o: 0
        },
        y: { ...sc.y },
        z: {
          ...sc.z,
          o: -1000
        }
      }
    }

    const tagIcons = {
      product: 'infospot" onloaded="do_crop_animation(128,128, 60);',
      document: 'documentspot" onloaded="do_crop_animation(128,128, 60);',
      desk: 'deskspot" onloaded="do_crop_animation(64,64, 60);',
      totem: 'deskspot" onloaded="do_crop_animation(64,64, 60);',
      group: 'groupspot" onloaded="do_crop_animation(128,128, 60);',
      chat: 'chatspot" onloaded="do_crop_animation(128,128, 60);',
      video: 'videospot" onloaded="do_crop_animation(128,128, 60);'
    }
    const tagSizes = {
      product: 0.6,
      document: 0.6,
      desk: 1.0,
      totem: 1.0,
      group: 0.6,
      chat: 0.6,
      video: 0.6
    }

    const headerXml = jsonData.tourFunctions.map(tagName => getXMLTag(tagName, tags)).join('')

    const additionalContentXml = jsonData.attributes.interactiveMap.enabled
      ? `
      <style name="mapspot" url="/contents/${process.env.VUE_APP_TOUR}/${jsonData.attributes.interactiveMap.viewpointImage}" keep="true" parent="map" zorder="2" align="lefttop" edge="center" scale="0.15"/>
      <style name="maplabel" keep="true" parent="map" align="lefttop" edge="lefttop" bg="true" bgcolor="0x303030" css="font-family: ${jsonData.attributes.interactiveMap.fontFamily}; font-weight:300; text-transform:uppercase; font-size:13px; color:#ffffff;" vcenter="true" padding="4 12" zorder="3"/>
      <layer name="mapcontainer" type="container" keep="true" align="leftbottom" preload="true" x="2.3%" y="2.5%" width="250" height="250" bgroundedge="125" bgshadow="5 5 20 000000 0.25" devices="!mobile">
      <layer name="scrollarea" url.html5="/krpano/plugins/scrollarea.js" align="center" preload="true" width="${jsonData.attributes.interactiveMap.width}" height="${jsonData.attributes.interactiveMap.height}" direction="all" draggable="true" mwheel="false" overscroll="0.0">
      <layer name="map" keep="true" url="/contents/${process.env.VUE_APP_TOUR}/${jsonData.attributes.interactiveMap.image}" alpha="0.9" handcursor="false" align="leftbottom" scalechildren="true" maskchildren="true" width="${jsonData.attributes.interactiveMap.width}" height="${jsonData.attributes.interactiveMap.height}" onover="set(layer[map].alpha, 1.0)" onout="set(layer[map].alpha, 0.9)" onclick="eventEmitter(tourMapClick)" /> </layer> </layer>
      <layer devices="!mobile" name="activespot" url="/contents/${process.env.VUE_APP_TOUR}/${jsonData.attributes.interactiveMap.activeViewpointImage}" keep="true" align="center" zorder="3" scale="0.25"/>
      <layer name="radar" devices="!mobile" enabled="false" keep="true" url.html5="/krpano/plugins/radar.js" align="center" zorder="1" scale="0.35" fillalpha="0.25" fillcolor="0x000000" linewidth="1.0" linecolor="0x000000" linealpha="0.3" />
      `
      : ''

    // TODO: togliere la query string dalla chiamata al popup
    // stringa in cui viene generato l'XML con la lista di scene, hotspot e tag
    const scenesXml = jsonData.viewpoints
      .map(
        viewpoint =>
          `${
            jsonData.attributes.interactiveMap.enabled &&
            !viewpoint.ghostViewpointFor &&
            jsonData.mapspots[viewpoint.name]
              ? `<layer devices="!mobile" name="mapspot${
                  jsonData.mapspots[viewpoint.name].linkedscene
                }" style="mapspot" x="${jsonData.mapspots[viewpoint.name].x}" y="${
                  jsonData.mapspots[viewpoint.name].y
                }" linkedscene="${
                  jsonData.mapspots[viewpoint.name].linkedscene
                }" onclick="map_layer_hotspot_click();" />
          ${
            jsonData.mapspots[viewpoint.name].label
              ? `<layer devices="!mobile" name="maplabel${
                  jsonData.mapspots[viewpoint.name].linkedscene
                }" style="maplabel" type="text" x="${jsonData.mapspots[viewpoint.name].label.x}" y="${
                  jsonData.mapspots[viewpoint.name].label.y
                }" html="${jsonData.mapspots[viewpoint.name].label.it}" it="${
                  jsonData.mapspots[viewpoint.name].label.it
                }" en="${jsonData.mapspots[viewpoint.name].label.en}" linkedscene="${
                  jsonData.mapspots[viewpoint.name].linkedscene
                }" onclick="map_layer_hotspot_click();" />`
              : ''
          }
          `
              : ''
          }
          <scene name="${viewpoint.name}" title="${viewpoint.name}" 
          onstart="${
            jsonData.attributes.interactiveMap.enabled && !viewpoint.ghostViewpointFor
              ? `update_radar(mapspot${viewpoint.name}, ${
                  jsonData.attributes.scene.startingViewPoint === viewpoint.name
                })`
              : ''
          }"
          autoload="${jsonData.attributes.scene.startingViewPoint === viewpoint.name}">

          <view fov="${jsonData.attributes.scene.fov ? jsonData.attributes.scene.fov : '90'}" fovmax="${
            jsonData.attributes.scene.fovmax ? jsonData.attributes.scene.fovmax : '105'
          }" fovmin="${jsonData.attributes.scene.fovmin ? jsonData.attributes.scene.fovmin : '1.0'}" fovtype="${
            jsonData.attributes.scene.fovtype ? jsonData.attributes.scene.fovtype : '1.0'
          }" mfovratio="${
            jsonData.attributes.scene.mfovratio ? jsonData.attributes.scene.mfovratio : '1.333333'
          }" hlookat="${
            jsonData.attributes.scene.startingHlookat ? jsonData.attributes.scene.startingHlookat : '90.0'
          }" limitview="${
            jsonData.attributes.scene.limitview ? jsonData.attributes.scene.limitview : 'auto'
          }" maxpixelzoom="${
            jsonData.attributes.scene.maxpixelzoom ? jsonData.attributes.scene.maxpixelzoom : '1.0'
          }" vlookat="0.0"
          tx="${viewpoint[sc.x.c] * sc.x.f + sc.x.o}"
          ty="${viewpoint[sc.y.c] * sc.y.f + sc.y.o}"
          tz="${viewpoint[sc.z.c] * sc.z.f + sc.z.o}"/>
          <preview url="${jsonData.assetsURL}/${
            jsonData.attributes.scene.multires ? 'cubemaps_multires' : 'cubemaps/krpano'
          }/${viewpoint.name}.tiles/preview.jpg" />
          <image
          ox="${viewpoint[sc.x.c] * sc.x.f + sc.x.o}"
          oy="${viewpoint[sc.y.c] * sc.y.f + sc.y.o}"
          oz="${viewpoint[sc.z.c] * sc.z.f + sc.z.o}">
            <cube
            url="${jsonData.assetsURL}/${
            viewpoint.isMultires || jsonData.attributes.scene.multires ? 'cubemaps_multires' : 'cubemaps/krpano'
          }/${viewpoint.name}.tiles/${
            viewpoint.isMultires || jsonData.attributes.scene.multires
              ? `%s/l%l/%0v/l%l_%s_%0v_%0h.jpg" multires="512,640,1280,2816,5632"`
              : `pano_%s.jpg"`
          }
          />
          ${
            jsonData.attributes.depthmap
              ? `<depthmap center="${viewpoint[sc.z.c]},${viewpoint[sc.y.c]},${viewpoint[sc.x.c] * -1}"
          rendermode="3dmodel" scale="100" url="${jsonData.assetsURL}/depthmaps/${jsonData.attributes.depthmap}.stl"/>`
              : ``
          }
          </image>
          ${jsonData.viewpoints
            .filter(
              hotspot =>
                !('hotspots' in viewpoint) ||
                viewpoint.hotspots.length == 0 ||
                viewpoint.hotspots.find(h => h.name === hotspot.name)
            )
            .map(
              (hotspot, index) =>
                `
                <hotspot
                tx="${hotspot[hs.x.c] * hs.x.f + hs.x.o}"
                ty="0"
                tz="${hotspot[hs.z.c] * hs.z.f + hs.z.o}"
                url="/krpano/skin/${
                  hotspot.moveTag
                    ? hotspot.moveTag
                    : jsonData.attributes.skin && jsonData.attributes.skin.moveTag
                    ? jsonData.attributes.skin.moveTag
                    : 'move_tag'
                }.png"
                scale="${
                  hotspot.moveTagScale
                    ? hotspot.moveTagScale
                    : jsonData.attributes.skin && jsonData.attributes.skin.moveTagScale
                    ? jsonData.attributes.skin.moveTagScale
                    : '1.0'
                }"
                rotationorder="xyz"
                mipmapping="true"
                linkedscene="${
                  hotspot.ghostViewpointFor ? hotspot.ghostViewpointFor : hotspot.name
                }" name="spot${index}"
                style="skin_hotspotstyle" rx="90" ry="${
                  viewpoint.hotspots.find(h => h.name === hotspot.name)
                    ? viewpoint.hotspots.find(h => h.name === hotspot.name).rotation
                    : 270
                }" rz="0"
                visible="${jsonData.attributes.scene.startingViewPoint === viewpoint.name ? 'true' : 'false'}"
                zorder="4"
                onover="tween(scale,${
                  hotspot.moveTagScale
                    ? hotspot.moveTagScale * 1.5
                    : jsonData.attributes.skin && jsonData.attributes.skin.moveTagScale
                    ? jsonData.attributes.skin.moveTagScale * 1.5
                    : '1.5'
                });" onout="tween(scale,${
                  hotspot.moveTagScale
                    ? hotspot.moveTagScale
                    : jsonData.attributes.skin && jsonData.attributes.skin.moveTagScale
                    ? jsonData.attributes.skin.moveTagScale
                    : '1.0'
                });"
                />`
            )
            .join('')}
          ${
            'tags' in viewpoint
              ? viewpoint.tags // spatial filtering
                  .map(
                    (popup, index) =>
                      `<hotspot html="" name="is${index}" onclick="eventEmitter(popupHotspotClick, ${popup})"
                      style="${tagIcons[jsonData.tags[popup].template]}"
                tx="${parseFloat(jsonData.tags[popup][hs.x.c]) * hs.x.f + hs.x.o}"
                ty="${parseFloat(jsonData.tags[popup][hs.y.c]) * hs.y.f + hs.y.o}"
                tz="${parseFloat(jsonData.tags[popup][hs.z.c]) * hs.z.f + hs.z.o}"
                visible="${jsonData.attributes.scene.startingViewPoint === viewpoint.name ? 'true' : 'false'}"
                scale.desktop="${tagSizes[jsonData.tags[popup].template].toString()}"
                scale.mobile="${(tagSizes[jsonData.tags[popup].template] / 2).toString()}"
                zorder="3"
                />`
                  )
                  .join('')
              : ''
          }

          ${jsonData.mediaHotspots
            .filter(media => media.settings.find(i => i.viewpoint === viewpoint.name))
            .map((media, index) => {
              const settings = media.settings.find(i => i.viewpoint === viewpoint.name)
              return `<hotspot name="media${index}"
                    ${
                      media.type === 'image'
                        ? `type="image"
                        url="${media.isExternal ? media.src : `${jsonData.assetsURL}/media/${media.src}`}"
                        zoom="true"
                        alpha="${settings.alpha ? settings.alpha : '1.0'}"
                        scale="${settings.scale ? settings.scale : '1.0'}"`
                        : `
                        url.html5="/krpano/plugins/videoplayer.js"
                        videourl="${media.isExternal ? media.src : `${jsonData.assetsURL}/media/${media.src}`}"
                        posterurl="${
                          media.isPosterExternal ? media.poster : `${jsonData.assetsURL}/media/${media.poster}`
                        }"
                        torigin="view"
                        scale.desktop="${settings.scale ? settings.scale : '0.0'}"
                        scale.tablet.or.mobile="${
                          settings.scaleMobile ? settings.scaleMobile : settings.scale ? settings.scale : '0.0'
                        }"
                        loop="${media.loop ? media.loop : 'false'}"
                        volume="${media.volume ? media.volume : '0.0'}"
                        autopause="true"
                        autoresume="true"
                        `
                    }
                    distorted="true"
                    zorder="2"
                    capture="false"
                    ath="${settings.ath ? settings.ath : '0.0'}"
                    atv="${settings.atv ? settings.atv : '0.0'}"
                    rx="${settings.rx ? settings.rx : '0.0'}"
                    ry="${settings.ry ? settings.ry : '0.0'}"
                    rz="${settings.rz ? settings.rz : '0.0'}"
                    ox="${settings.ox ? settings.ox : '0.0'}"
                    oy="${settings.oy ? settings.oy : '0.0'}"
                    ${
                      media.actionType
                        ? `onclick="${
                            media.actionType === 'popup'
                              ? `eventEmitter(popupHotspotClick, ${media.actionContent})`
                              : `${
                                  media.actionContent[0] === '?'
                                    ? `openurl(${media.actionContent.replace('&', '&amp;')}, _self)`
                                    : `openurl(${media.actionContent.replace('&', '&amp;')}`
                                }`
                          }"`
                        : 'handcursor="false"'
                    }
                  />`
            })
            .join('')}

        </scene>
        `
      )
      .join('')

    /**
     * APPUNTI
     * Sarebbe sensato che la costruzione lato frontend sia parametrizzata maggiormente
     * ovvero una serie di attributi definiscano anche, per esempio,
     * se usare il preload
     * la skin
     * cosa e come visualizzare gli hotspot
     */
    const xmlString = `
    <krpano>
      ${headerXml}
      ${additionalContentXml}
      ${scenesXml}
    </krpano>`
    return xmlString
  } else {
    log(jsonData)
    throw 'jsonData not formatted correctly'
  }
}

/* ottiene la stringa da inserire nell'XML a partire dal suo nome, nel JSON delle action TODO: JSON nel backend
 * le stringe contengono, se parametrizzate, una sottostringa "_ACTION_PARAM_" che deve passare come argomenti successivi al primo
 */
const getXMLTag = (tagName, tags) => {
  let tagString = tags[tagName]
  let argumentIndex = 1
  //eslint-disable-next-line
  let argumentsArray = Array.from(arguments)
  while (tagString.indexOf('_ACTION_PARAM_') > 0) {
    if (typeof argumentsArray[argumentIndex] !== 'undefined') {
      tagString = tagString.replace('_ACTION_PARAM_', argumentsArray[argumentIndex])
    } else {
      throw `Not enough argument passed for action ${tagName}`
    }
  }
  return tagString
}

export default createXML
